/**
 * Node modules
 */
import Select from 'antd/lib/select';

/**
 * Functional components
 */
export default Select.Option;
